import { PartialTranslation } from '../translations';

export const es_ES: PartialTranslation = {
  newChat: 'Nuevo Chat',
  search: 'Buscar',
  user: 'Usuario',
  settings: 'Configuración',
  language: 'Idioma',
  getHelp: 'Obtener ayuda',
  viewAllPlans: 'Ver todos los planes',
  learnMore: 'Aprender más',
  logOut: 'Cerrar sesión',
  chooseLanguage: 'Elegir Idioma',
  chooseYourPreferredLanguage: 'Elige tu idioma preferido',
  searchLanguages: 'Buscar idiomas...',
  autoDetect: 'Detección automática',
  noLanguagesFound: 'No se encontraron idiomas',
  askAnything: 'Pregunta cualquier cosa',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personal',
  freePlan: 'Plan gratuito',
  current: 'Actual',
  close: 'Cerrar',
  archive: 'Archivar',
  delete: 'Eliminar',
  confirmDelete: '¿Estás seguro de que quieres eliminar este chat?',
  confirmArchive: '¿Estás seguro de que quieres archivar este chat?',
  deleteCannotUndo: 'Esta acción no se puede deshacer.',
  archiveCanFind: 'Puedes encontrarlo en la lista de archivos después del archivado.',

  // 归档标签页
  chats: 'Chats',
  archived: 'Archivado',
  restore: 'Restaurar',
  noArchivedChats: 'No hay chats archivados',
  backToChats: 'Volver a chats',

  // 资源面板
  resources: 'Recursos',
  addResource: 'Agregar recurso',
  deleteResource: 'Eliminar recurso',
  noMatchingResourcesFound: 'No se encontraron recursos coincidentes',
  noResourcesAvailable: 'No hay recursos disponibles',
  hideResources: 'Ocultar recursos',
  showResources: 'Mostrar recursos',

  // 聊天输入框
  typeMessage: 'Escribe un mensaje...',
  thinkingOptions: 'Opciones de pensamiento',
  deleteFile: 'Eliminar archivo',
  clearSelection: 'Limpiar selección',
  addAttachment: 'Agregar adjunto',
  sendMessage: 'Enviar mensaje',

  // 思考模式选项
  deepInsight: 'Perspicacia Profunda · Análisis Superficial',
  deepInsightDesc: 'Comprensión rápida de puntos clave',
  deepExploration: 'Exploración Profunda · Análisis Integral',
  deepExplorationDesc: 'Investigación profunda multidimensional',
  deepDeconstruction: 'Deconstrucción Profunda · Argumento Sistemático',
  deepDeconstructionDesc: 'Análisis progresivo capa por capa',

  // 写作模式选项
  contractReview: 'Revisión de Contrato · Identificación de Riesgos',
  contractReviewDesc: 'Análisis de cláusulas y verificación de cumplimiento',
  textPolish: 'Pulido de Texto · Expresión Profesional',
  textPolishDesc: 'Optimización del lenguaje y ajuste estructural',
  legalDocuments: 'Documentos Legales · Redacción Estándar',
  legalDocumentsDesc: 'Redacción profesional de documentos legales',

  // 认证和隐私翻译
  login: 'Iniciar sesión',
  register: 'Registrarse',
  welcomeBack: 'Bienvenido a LawHelper',
  loginSubtitle: 'Tu Asistente IA de Investigación Legal',
  continueWithGoogle: 'Continuar con Google',
  continueWithMicrosoft: 'Continuar con Microsoft',
  continueWithWeChat: 'Continuar con WeChat',
  orContinueWith: 'o continuar con',
  emailTab: 'Correo electrónico',
  phoneTab: 'Teléfono',
  emailPlaceholder: 'Introduce tu correo',
  phonePlaceholder: 'Introduce el número de teléfono',
  codePlaceholder: 'Introduce el código de 6 dígitos',
  sending: 'Enviando...',
  verifying: 'Verificando...',
  verify: 'Verificar',
  sendMagicLink: 'Enviar enlace mágico',
  getVerificationCode: 'Obtener código',
  resendCode: 'Reenviar código',
  resendIn: 'Reenviar en',
  magicLinkSent: 'Enlace mágico enviado a tu correo',
  magicLinkHint: 'Enviaremos un enlace seguro a tu correo',
  otpSent: 'Código de verificación enviado',
  agreeToTerms: 'Al continuar, aceptas nuestras',
  privacyPolicy: 'Política de Privacidad',
  termsOfService: 'Términos de Servicio',
  and: 'y',
  privacyTitle: 'Tu privacidad importa',
  privacyIntro: 'Usamos cookies y tecnologías similares para ofrecerte la mejor experiencia.',
  essentialCookies: 'Cookies esenciales',
  essentialDesc: 'Necesarias para el funcionamiento del sitio',
  analyticsCookies: 'Cookies analíticas',
  analyticsDesc: 'Nos ayudan a mejorar nuestro servicio',
  marketingCookies: 'Cookies de marketing',
  marketingDesc: 'Usadas para contenido personalizado',
  acceptAll: 'Aceptar todo',
  essentialOnly: 'Solo esenciales',
  customize: 'Personalizar',
  savePreferences: 'Guardar preferencias',
  back: 'Volver',
  readPrivacyPolicy: 'Leer nuestra política de privacidad',
  cookiePolicy: 'Política de cookies',
  gdprCompliance: 'RGPD',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Revisión IA',
  aiDraft: 'Redacción IA',
  smartAssistant: 'Plantilla',

  // 知识库搜索
  enableKnowledgeSearch: 'Activar búsqueda',
  knowledgeSearchDesc: 'IA busca en sus documentos',
  clickToDisable: 'Desactivar',
  clickToEnable: 'Activar',

  // Landing page translations
  tagline: 'Inteligencia legal con IA',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplificado.',
  jurisdictionsLabel: 'Jurisdicciones',
  accuracyLabel: 'Precisión',
  fasterLabel: 'Más rápido',
  availableLabel: 'Disponible',
  platformCapabilities: 'Funciones',
  testimonialQuote: '"LawHelper transformó nuestro trabajo."',
  testimonialAuthor: 'Profesional',
  testimonialPosition: 'Socio',
  viewPricing: 'Precios',
  footerPricing: 'Precios',
  footerPrivacy: 'Privacidad',
  footerTerms: 'Términos',
  footerContact: 'Contacto',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  closeResourcesPanel: 'Cerrar panel de recursos',
  uploading: 'Subiendo %{fileName}...',
  processing: 'Procesando %{fileName}...',
  uploadSuccess: '✓ %{fileName} subido correctamente',
  uploadError: '✗ Error al subir: %{error}',
  quickAnswer: 'Respuesta rápida',
  quickAnswerDesc: 'Respuesta rápida para preguntas simples',
  cancelRequest: 'Cancelar',
  library: 'Biblioteca',
  filterAll: 'Todo',
  filterChat: 'Chats',
  filterReview: 'Revisión',
  filterDraft: 'Borrador',
  filterTemplate: 'Plantilla',
  filterForm: 'Formulario',
  thinking: 'Pensando...',
  thinkingProcess: 'Proceso de pensamiento',
  analyzingLegalLogic: 'Analizando lógica jurídica...',
  lawhelperThinking: 'Lawhelper está pensando...',
  serviceError: 'Error del servicio',
  uploaded: 'Subido',
  settingsGeneral: 'General',
  settingsNotifications: 'Notificaciones',
  settingsAppearance: 'Apariencia',
  settingsProfile: 'Perfil',
  settingsResponseNotifications: 'Notificaciones de respuesta',
  settingsResponseNotificationsDesc: 'Recibir notificación al completar respuesta IA',
  settingsColorMode: 'Modo de color',
  settingsLight: 'Claro',
  settingsDark: 'Oscuro',
  settingsSystem: 'Sistema',
  about: 'Acerca de',
  reviewTitle: 'Revisión de documentos',
  exitReview: 'Salir de revisión',
  uploadPrompt: 'Sube un PDF para iniciar la revisión',
  uploadButton: 'Seleccionar archivo',
  startChatConfig: 'Escribe "Revisar este documento" para comenzar',
  reviewPlaceholder: 'Escribe un mensaje o "Revisar este documento"...',
  analyzing: 'Revisando...',
  reviewComplete: 'Revisión completa',
  issuesFound: 'Se encontraron %{count} problemas',
  draftTitle: 'Redacción de documentos legales',
  draftPlaceholder: 'Edite aquí o pida a la IA que genere...',
  analyzingTemplate: 'Analizando plantilla %{name}...',
  templateAnalyzed: '✅ Plantilla %{name} analizada. Indique cómo desea modificarla.',
  templateAnalysisPrompt: 'Analizar cláusulas clave de la plantilla',
  parsingFailed: '⚠️ No se pudo analizar el archivo, pero puede describir sus necesidades.',
  generating: 'Generando...',
  generatedSuccess: '✅ Documento generado. Puede verlo y editarlo en el editor.',
  drafterWelcome: 'Bienvenido al Asistente IA de Documentos',
  drafterYouCan: 'Puede:',
  drafterUploadTemplate: 'Subir una plantilla para análisis IA',
  drafterDescribeNeeds: 'Describir sus requisitos documentales',
  drafterLetAiHelp: 'La IA le ayuda a redactar contratos, acuerdos, etc.',
  drafterExamples: 'Ejemplos:',
  drafterExampleRental: '"Redacte un contrato de alquiler"',
  drafterExampleLabor: '"Complete el contrato laboral según la plantilla"',
  drafterInputPlaceholder: 'Describa sus necesidades documentales...',
  drafterThinking: 'Pensando...',
  drafterHistoryTitle: 'Historial',
  drafterNoHistory: 'Sin historial',
  drafterNewChat: 'Nuevo chat',
  drafterHistory: 'Historial',
  drafterRemoveAttachment: 'Eliminar adjunto',
  drafterLineHeight: 'Interlineado',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Exportar como Word (.docx)',
  drafterExportPdf: 'Exportar como PDF',
  drafterSave: 'Guardar documento',
  drafterDownload: 'Descargar documento',
  drafterUndo: 'Deshacer',
  drafterRedo: 'Rehacer',
  drafterBold: 'Negrita',
  drafterItalic: 'Cursiva',
  drafterStrike: 'Tachado',
  drafterUnderline: 'Subrayado',
  drafterHighlight: 'Resaltar',
  drafterLink: 'Insertar enlace',
  drafterAlignLeft: 'Alinear a la izquierda',
  drafterAlignCenter: 'Centrar',
  drafterAlignRight: 'Alinear a la derecha',
  drafterAlignJustify: 'Justificar',
  drafterList: 'Lista',
  drafterBulletList: 'Lista con viñetas',
  drafterOrderedList: 'Lista numerada',
  drafterTaskList: 'Lista de tareas',
  drafterOpenResource: 'Abrir panel de recursos',
  drafterStopGeneration: 'Detener generación',
  drafterAgentMode: 'Modo Agente activo | Clic para chat normal',
  drafterAgentModeOn: 'Modo Agente activo | Clic para chat normal',
  drafterAgentModeOff: 'Modo chat normal | Clic para modo Agente',
  drafterUploadAttachment: 'Subir adjunto',
  drafterExit: 'Salir',
  drafterConfirm: 'Confirmar',
  drafterOpenLink: 'Abrir enlace',
  drafterDeleteLink: 'Eliminar enlace',
  drafterQuote: 'Cita',
  workflowTitle: 'Flujo de trabajo IA',
  workflowRunning: 'Ejecutando...',
  workflowReady: 'Listo',
  workflowCompleted: 'Completado',
  workflowStartFailed: 'Error al iniciar el flujo',
  workflowExecutionFailed: 'Error en la ejecución del flujo',
  workflowInterrupted: 'Flujo interrumpido',
  workflowProcessing: 'Procesando...',
  workflowStepsCompleted: 'pasos completados',
  workflowStepsTotal: 'Flujo completado (%{count} pasos)',
  acceptChanges: 'Aceptar cambios',
  rejectChanges: 'Rechazar cambios',
  changesAccepted: 'Cambios aceptados',
  changesRejected: 'Cambios rechazados',
  stopWorkflow: 'Detener',
  restartWorkflow: 'Reiniciar',
  startDrafting: 'Iniciar redacción',
  interrupt: 'Detener',
  documentSubject: 'Asunto del documento *',
  documentType: 'Tipo de documento',
  jurisdiction: 'Jurisdicción',
  specialRequirements: 'Requisitos especiales (opcional)',
  clickStartDrafting: 'Haga clic en "Iniciar redacción" para comenzar',
  docTypeContract: 'Contrato',
  docTypeAgreement: 'Acuerdo',
  docTypeNotice: 'Notificación',
  docTypeLetter: 'Carta',
  docTypePetition: 'Petición',
  docTypeWill: 'Testamento',
  docTypePowerOfAttorney: 'Poder notarial',
  countryChina: 'China',
  countryUSA: 'Estados Unidos',
  countryGermany: 'Alemania',
  countryJapan: 'Japón',
  countryFrance: 'Francia',
  countryUK: 'Reino Unido',
  citationVerified: 'Verificado',
  citationUnverified: 'No verificado',
  imageLoadFailed: 'Error al cargar la imagen',
  smartDocTitle: 'Asistente inteligente de documentos',
  smartDocChatTitle: 'Asistente IA de documentos',
  smartDocDropPrompt: 'Suelte archivo PDF aquí',
  smartDocSelectFile: 'Seleccionar archivo',
  smartDocOr: 'o',
  smartDocWelcomeTitle: 'Bienvenido al Asistente IA de Documentos',
  smartDocWelcomeYouCan: 'Puede:',
  smartDocUploadForAI: 'Subir plantilla para análisis IA',
  smartDocDescribeDoc: 'Describir sus requisitos',
  smartDocLetAIDraft: 'La IA le ayuda a redactar contratos',
  smartDocExamples: 'Ejemplos:',
  smartDocExampleRental: '"Redacte un contrato de alquiler"',
  smartDocExampleLabor: '"Complete el contrato laboral"',
  smartDocInputPlaceholder: 'Describa sus necesidades documentales...',
  smartDocRemoveAttachment: 'Eliminar adjunto',
  smartDocOpenResources: 'Abrir panel de recursos',
  smartDocExit: 'Salir',
  reviewStartFailed: 'Error al iniciar revisión',
  reviewFailed: 'Revisión fallida',
  reviewFoundIssues: 'Revisión completa, %{count} problemas encontrados.',
  cannotReadStream: 'No se puede leer el flujo de respuesta',
  parseEventFailed: 'Error al analizar evento del flujo',
  errorPrefix: 'Error',
  unknownError: 'Error desconocido',
  file: 'Archivo',
  loading: 'Cargando...',
  localFolders: 'Carpetas locales',
  selectLocalFolder: 'Seleccionar carpeta local',
  reselectFolder: 'Cambiar carpeta',
  addToContext: 'Añadir al chat',
  saveFile: 'Guardar',
  renameFile: 'Renombrar',
  fileSaved: 'Archivo guardado',
  fileRenamed: 'Archivo renombrado a %{name}',
  browserNotSupported: 'Su navegador no admite acceso a carpetas locales',
  noFolderSelected: 'Seleccione una carpeta local para explorar archivos',
  scanningFolder: 'Escaneando carpeta...',
  selectFileToPreview: 'Seleccione un archivo para previsualizar',
  aiAnalyze: 'Análisis IA',
};
